import React, { useState } from "react";
import { RenderType } from "../../../../Enums/RenderType";
import {
    IBrand,
    IRetailMatchJobResult,
    IRetailMatchOverview,
    IStoreScoreRecord,
} from "../../../../Models/Models";
import { getDateBackVerbiage } from "../../../../Util/RetailMatch/RetailMatchUtil";
import { SiteDetailsContainer } from "../Styled/RetailMatchIntroStyles";
import { RetailMatchEditAddressModal } from "./RetailMatchEditAddressModal";
import RetailMatchIntroTextHeader from "./RetailMatchIntroTextHeader";
import RetailMatchIntroTextIndexBreakout from "./RetailMatchIntroTextIndexBreakout";
import RetailMatchMultiBrandIndexBreakout from "./RetailMatchMultiBrandIndexBreakout";

interface IRetailMatchIntroTextProps {
  multiBrand: boolean;
  jobResult: IRetailMatchJobResult;
  address: string;
  overview: IRetailMatchOverview[];
  isSharing: boolean;
  benchmarkAddressOverride: IStoreScoreRecord;
  brand: IBrand;
  renderType: RenderType;
}

export const RetailMatchIntroText = ({
    jobResult,
    address,
    overview,
    isSharing,
    benchmarkAddressOverride,
    multiBrand,
    brand,
    renderType,
}: IRetailMatchIntroTextProps): JSX.Element => {
    const job = jobResult?.job;

    const showSiteDetails = (): boolean => {
        if (!isSharing) return true;

        return job.siteDetails != null;
    };

    const [editAddressModalVisible, setEditAddressModalVisible]
    = useState<boolean>(false);

    const overviewRecord = overview.find((record) => {
        return record.brandId === brand?.brandId;
    });

    return (
        <>
            <RetailMatchEditAddressModal
                visible={editAddressModalVisible}
                defaultAddress={benchmarkAddressOverride.addr}
                defaultCity={benchmarkAddressOverride.city}
                defaultState={benchmarkAddressOverride.st}
                defaultZipcode={benchmarkAddressOverride.zip}
                hide={() => setEditAddressModalVisible(false)}
            />
            <RetailMatchIntroTextHeader
                address={address}
                isSharing={isSharing}
                multiBrand={multiBrand}
                sampleCount={overviewRecord?.sampleCount}
                brandName={overviewRecord?.brandName}
                brand={brand}
                backDateVerbiage={getDateBackVerbiage(job.startDate, job.endDate)}
                showEditAddressModal={() => setEditAddressModalVisible(true)}
            />
            {multiBrand ? (
                <RetailMatchMultiBrandIndexBreakout
                    jobResult={jobResult}
                    isSharing={isSharing}
                    renderType={renderType}
                />
            ) : (
                <RetailMatchIntroTextIndexBreakout overview={overviewRecord} />
            )}
            <SiteDetailsContainer show={showSiteDetails()}>
                <h3
                    style={{
                        color: "#242831",
                        fontSize: 15,
                        marginLeft: 0,
                        paddingLeft: 0,
                    }}
                >
          SITE DETAILS
                </h3>
                {!job.siteDetails || job.siteDetails.trim().length === 0
                    ? `No details listed for this site.To add some, click 'Add Site Details'`
                    : job.siteDetails}
            </SiteDetailsContainer>
        </>
    );
};
